import { StatelessComponent } from 'react'
import * as styles from 'components/features/pfm/Subtitle/Subtitle.css'

const Subtitle: StatelessComponent = (props) => {
  return (
    <section className={ styles.subtitle }>
      { props.children }
    </section>
  )
}

export default Subtitle
